import { SET_INVOICES_LIST } from "./constants";
  
  const initialState= {
    invoice:[]
  };
  
  const Invoices= (state= initialState, action) => {
    switch (action.type) {
      case SET_INVOICES_LIST: {
        const { invoice } = action.payload;
        return {
          ...state,
         invoice:invoice
        };
      }
     
      default: {
        return state;
      }
    }
  };

  export default Invoices;
  